<template>
  <div class='newSQF'>
    <div class="row row1">
      <a :href="`${item.url ? $Path + item.url : 'javascript:void(0);' }`" class="href" v-for="(item, index) in row1Images" :key="index">
        <div :class="['bg', 'bg'+ index]" :style="{'background-image': `url(${require(`../assets/newsqf/${index+1}-1.png`)})`}">
          <img :class="['product', 'product' + index]" :src="require(`@/assets/newsqf/${index+1}.png`)" alt="">
          <div class="mask"></div>
          <div class="title-content">
            <p class="title">{{item.title}}</p>
            <p class="desc">{{item.desc}}</p>
            <p class="more">了解更多 <img src="@/assets/newsqf/arrow.png" alt=""></p>
          </div>
        </div>
      </a>
    </div>
    <div class="row row2">
      <a :href="`${item.url ? $Path + item.url : 'javascript:void(0);' }`" class="href" v-for="(item, index) in row2Images" :key="index + 3">
        <div :class="['bg', 'bg'+ (index + 3)]" :style="{'background-image': `url(${require(`../assets/newsqf/${index+4}-1.png`)})`}">
          <img :class="['product', 'product' + (index + 3)]" :src="require(`@/assets/newsqf/${index+4}.png`)" alt="">
          <div class="mask"></div>
          <div class="title-content">
            <p class="title">{{item.title}}</p>
            <p class="desc">{{item.desc}}</p>
            <p class="more">了解更多 <img src="@/assets/newsqf/arrow.png" alt=""></p>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'newSQF',
  components:{ 
    
  },
  data() {
    return {
      imageArr: [
        {
          title: '实木水漆大板',
          desc: '科技饰面工艺 净味水性漆',
          url: '/#/family/kechuang'
        },
        {
          title: '安芯漆面板',
          desc: '智能涂层  UV3D面漆',
          url: '/#/family/anxin'
        },
        {
          title: '森格板',
          desc: '进口材料  极致美感',
          url: '/#/family/senge'
        },
        {
          title: '康芯板',
          desc: 'ENF级高环保 臻选花色板',
          url: '/#/family/kangxin'
        },
        {
          title: '晶瓷板 ',
          desc: '高端饰面  A级防火板',
          url: '/#/family/jingci'
        },
        {
          title: '水性绿芯无醛胶',
          desc: '无醛添加  高性能板材专用胶',
          url: '/#/family/lvxin'
        },
        {
          title: '辅材 ',
          desc: '高品质配套物解决方案',
          url: '/#/family/fucai'
        }
      ]
    }
  },
  computed:{ 
    row1Images() {
      return this.imageArr.slice(0, 3);
    },
    row2Images() {
      return this.imageArr.slice(3);
    }
  },
  watch:{ },
  created() {
      
  },
  mounted() {
      
  },
  methods: {
      
  }
}
</script>
<style lang='less' scoped>
.newSQF {
  width: 100%;
  max-width: 1920px;
  box-sizing: border-box;
  margin: 30px auto;
  .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .row2 {
    margin-top: 30px;
  }
  .href {
    cursor: pointer;
    margin-right: 25px;
    &:last-child {
      margin-right: 0;
    }
  }
  .bg {
    position: relative;
    width: 603px;
    height: 346px;
    overflow: hidden;
    background-size: 100% 100%;
    background-position: center;
    &:hover .product {
      transform: scale(1.05);
    }
    &:hover .mask {
      // background:  rgba(0, 0, 0, 0.3);
      background: linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.7) 100%);
    }
    &:hover .title-content {
      bottom: 0;
    }
    &.bg3, &.bg4, &.bg5, &.bg6 {
      width: 446px;
      height: 315px;
    }
    .product {
      position: absolute;
      transition: all 0.5s linear;
      z-index: 4;
      &.product0 {
        width: 161px;
        height: 262px;
        top: 35px;
        left: 357px;
      }
      &.product1 {
        width: 163px;
        height: 263px;
        top: 35px;
        left: 355px;
      }
      &.product2 {
        width: 163px;
        height: 263px;
        top: 35px;
        left: 360px;
      }
      &.product3 {
        width: 138px;
        height: 224px;
        top: 30px;
        left: 263px;
      }
      &.product4 {
        width: 145px;
        height: 231px;
        top: 23px;
        left: 260px;
      }
      &.product5 {
        width: 219px;
        height: 187px;
        top: 46px;
        left: 225px;
      }
      &.product6 {
        width: 217px;
        height: 134px;
        top: 79px;
        left: 192px;
      }
    }
    .mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 2;
      transition: all 0.5s linear;
      cursor: pointer;
      background: linear-gradient(to bottom, transparent 60%, rgba(0, 0, 0, 0.7) 100%);
    }
  }
  .title-content {
    position: absolute;
    bottom: -35px;
    left: 38px;
    z-index: 3;
    transition: all 0.5s linear;
    // background: linear-gradient(to bottom, transparent 20%, rgba(0, 0, 0, 1) 100%);
    text-align: left;
    overflow: hidden;
    .title {
      font-weight: 400;
      font-size: 34px;
      color: #FFFFFF;
      margin-bottom: 7px;
      padding: 0;
      text-align: left;
    }
    .desc {
      font-weight: 400;
      font-size: 17px;
      color: #FFFFFF;
      line-height: 5px;
      margin-bottom: 14px;
    }
    .more {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 17px;
      color: #FFFFFF;
      line-height: 5px;
      img {
        width: 10px;
        height: 18px;
        margin-left: 10px;
      }
    }
  }
}
</style>